// Fereastra de mesaje directe, andocată jos-dreapta.
//
// Înainte era o fereastră modală în mijlocul ecranului, cu fundalul întunecat. Asta e
// potrivit pentru o întrebare la care trebuie să răspunzi acum („ştergi publicaţia?"),
// dar nu pentru o conversaţie: un mesaj se scrie **în timp ce** te uiţi la altceva, iar
// o fereastră modală îţi ia tocmai acel altceva. De aceea stă în colţ, ca pe Facebook,
// şi restul paginii rămâne viu sub ea.
//
// Una singură deodată. Trei ferestre de chat suprapuse pe un ecran de laptop sunt un
// tipar pe care l-au încercat toţi şi l-au strâns înapoi toţi.

import { el, clear } from '../core/util.js';
import { icon } from './icons.js';
import { pictAvatar } from './avatars.js';
import { toast } from './components.js';

const json = async (path, body) => {
  const resp = await fetch(path, body
    ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }
    : {});
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) throw new Error(data.detail || `Ошибка ${resp.status}`);
  return data;
};

/** Cât de des recitim conversaţia deschisă. */
const REIMPROSPATARE = 8000;

function cand(ts) {
  const s = Math.floor(Date.now() / 1000) - ts;
  if (s < 60) return 'сейчас';
  if (s < 3600) return `${Math.floor(s / 60)} мин`;
  if (s < 86400) return `${Math.floor(s / 3600)} ч`;
  return new Date(ts * 1000).toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' });
}

let deschisa = null;

/** Deschide conversaţia cu cineva. A doua chemare pentru acelaşi om doar o aduce în faţă. */
export function deschideMesaje(nume) {
  if (deschisa?.nume === nume) { deschisa.desfa(); return deschisa; }
  deschisa?.inchide();

  const lista = el('div', { class: 'dm-lista' });
  const camp = el('input', { class: 'fd-com-input', type: 'text', maxlength: 800,
    placeholder: 'Сообщение…' });
  const capAvatar = el('span', { class: 'fd-av mic' });

  const panou = el('section', { class: 'dm-doc' }, [
    el('header', { class: 'dm-cap' }, [
      capAvatar,
      el('button', { class: 'dm-cap-nume', text: nume,
        onclick: () => { location.href = `/profile/${encodeURIComponent(nume)}/`; } }),
      el('button', { class: 'dm-cap-btn', title: 'Свернуть',
        onclick: () => panou.classList.toggle('strans') }, [icon('chevronDown', 12)]),
      el('button', { class: 'dm-cap-btn', title: 'Закрыть',
        onclick: () => inchide() }, [icon('close', 12)]),
    ]),
    lista,
    el('div', { class: 'dm-scrie' }, [
      camp,
      el('button', { class: 'fd-com-send', onclick: () => trimite() }, [icon('send', 12)]),
    ]),
  ]);

  const deseneaza = (d) => {
    // Dacă eşti deja jos, coborâm şi după mesajul nou; dacă citeai mai sus, te lăsăm
    // acolo — altfel fiecare reîmprospătare te smulge din locul unde citeai.
    const eraJos = lista.scrollTop + lista.clientHeight >= lista.scrollHeight - 30;
    clear(lista);
    if (d.user) pictAvatar(capAvatar, d.user, 26);
    if (!d.messages.length) {
      lista.append(el('div', { class: 'fd-gol-mic', text: 'Переписки ещё нет' }));
    }
    for (const m of d.messages) {
      lista.append(el('div', { class: `dm-msg${m.mine ? ' al-meu' : ''}` }, [
        el('span', { class: 'dm-text', text: m.text }),
        el('span', { class: 'dm-cand', text: cand(m.created_at) }),
      ]));
    }
    if (eraJos) lista.scrollTop = lista.scrollHeight;
  };

  const trimite = async () => {
    const text = camp.value.trim();
    if (!text) return;
    camp.value = '';
    try { deseneaza(await json(`/api/dm/${encodeURIComponent(nume)}`, { text })); }
    catch (err) { toast(err.message, 'error'); }
  };
  camp.onkeydown = (e) => { if (e.key === 'Enter') trimite(); };

  const reincarca = async () => {
    try { deseneaza(await json(`/api/dm/${encodeURIComponent(nume)}`)); }
    catch { /* o pierdere de reţea nu are de ce să golească fereastra */ }
  };

  document.body.append(panou);
  const ceas = setInterval(reincarca, REIMPROSPATARE);
  reincarca();
  setTimeout(() => camp.focus(), 60);

  const inchide = () => {
    clearInterval(ceas);
    panou.remove();
    if (deschisa?.panou === panou) deschisa = null;
  };

  deschisa = {
    nume, panou, inchide,
    desfa: () => { panou.classList.remove('strans'); camp.focus(); },
  };
  return deschisa;
}
